import { sendRequest } from './api';

const BASE_URL = 'me';

export const getCurrentUser = () => {
    return sendRequest(BASE_URL);
};
